import proyecto from "../../api/Proyecto";

export const abrirCaja = async ({ id_caja = 1, monto_inicial = 0, observaciones = null } = {}) => {
  const response = await proyecto.post("/caja/abrir", { id_caja, monto_inicial, observaciones });
  return response.data;
};

export const cajaActual = async ({ id_caja = 1 } = {}) => {
  const response = await proyecto.get("/caja/actual", { params: { id_caja } });
  return response.data; // { sesion }
};

export const cerrarCaja = async ({
  id_caja = 1,
  monto_cierre_reportado,
  observaciones = null,
} = {}) => {
  const response = await proyecto.post("/caja/cerrar", {
    id_caja,
    monto_cierre_reportado,
    observaciones,
  });
  return response.data;
};

export const movimientosCaja = async ({ id_caja_sesion } = {}) => {
  const response = await proyecto.get("/caja/movimientos", { params: { id_caja_sesion } });
  return response.data;
};

export const reporteCajaSesion = async ({ id_caja_sesion } = {}) => {
  const response = await proyecto.get("/caja/reporte", { params: { id_caja_sesion } });
  return response.data;
};

export const registrarMovimientoManual = async ({
  id_caja = 1,
  tipo,
  categoria = "OTROS",
  metodo_pago = "EFECTIVO",
  monto,
  descripcion = null,
} = {}) => {
  const response = await proyecto.post("/caja/movimientos", {
    id_caja,
    tipo,
    categoria,
    metodo_pago,
    monto,
    descripcion,
  });
  return response.data;
};
